/**
 * "GESCHENKMODUS" — Signature 5, live preview only.
 * Mirrors whatever is typed in the cart note textarea (both the cart page
 * and the drawer render their own copy, different IDs, same `name="note"`)
 * onto the wax-paper preview card(s) rendered by candy-gift-preview.liquid.
 * Pure UI delight — the actual note value still submits through Dawn's own
 * <cart-note> element exactly as before; this script never reads from or
 * writes to the cart itself.
 */
(function () {
  function updatePreviews(text) {
    var trimmed = text.trim();
    document.querySelectorAll('[data-gift-preview-text]').forEach(function (el) {
      el.textContent = trimmed.length ? trimmed : '🍬';
      el.classList.toggle('is-placeholder', trimmed.length === 0);
    });
  }

  document.addEventListener('input', function (event) {
    if (!(event.target instanceof HTMLTextAreaElement)) return;
    if (event.target.name !== 'note') return;
    updatePreviews(event.target.value);
  });

  function initFromExistingValue() {
    var textarea = document.querySelector('textarea[name="note"]');
    if (textarea && textarea.value) updatePreviews(textarea.value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromExistingValue);
  } else {
    initFromExistingValue();
  }
})();
